import { render, staticRenderFns } from "./rmaOrderOEM.vue?vue&type=template&id=5a5571ce&"
import script from "./rmaOrderOEM.vue?vue&type=script&lang=ts&"
export * from "./rmaOrderOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports